import { rootElement } from '@shared/setup';
import ProcessingTasks from './ProcessingTasks.vue';

const init = async () => {
    rootElement({
        name: 'ProcessingTasks',
        component: ProcessingTasks,
        vm: {},
        contextComponents: ['<div>loading...</div>'],
    });
};
init();
